import React, { Component } from 'react';
import {
  Alert,
  FlatList,
  InteractionManager,
  PixelRatio,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';
import { FontAwesomeIcon } from '../modules';
import Utils from '../utils/Utils';
import APIClient from '../utils/APIClient';
import SearchInput from '../common/SearchInput';
import Empty from '../common/Empty';

const ITEM_HEIGHT = 48;

class PartnerListScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {routes, params} = navigation.state;
    const {updateQuery, search} = params ? params : {};
    return {
      tabBarIcon: ({focused, tintColor}) => {
        return (
          <FontAwesomeIcon
            name='user-plus'
            size={24}
            color={tintColor}/>
        );
      },
      tabBarVisible: !routes || routes.length <= 1,

      headerBackTitle: null,
      headerTitle: (
        <SearchInput
          placeholder='Emai / số điện thoại đối tác'
          onUpdateQuery={updateQuery}
          onSubmit={search}/>
      ),
    };
  };

  constructor (props) {
    super(props);

    const items = [];
    this.state = {
      refreshing: false,
      items: items,
      noitem: false,
    };

    this._page = -1;
    this._loading = false;
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
    } else {
      const {navigation} = this.props;
      navigation.setParams({
        updateQuery: this._updateQuery,
        search: this._search,
      });
    }

    InteractionManager.runAfterInteractions(() => {
      this._refreshData(true);
    });
  }

  componentWillUnmount () {
  }

  _updateQuery = (query) => {
    if (this._query === query) {
      return;
    }

    this._query = query;
    this.setState({
      query: query,
    });
    if (Platform.OS !== 'web') {
      this.props.navigation.setParams({
        query: query,
      });
    }
  };

  _search = () => {
    this._refreshData(false);
  };

  _refreshData (refreshing) {
    if (this._loading) {
      return;
    }

    this._resetData(refreshing);
    this._loadData();
  }

  _resetData (refreshing) {
    this._loading = false;
    this._page = 1;
    const items = [];
    this.setState({
      refreshing: refreshing,
      items: items,
      noitem: false,
    });
  }

  _loadData = async () => {
    if (this._loading || this._page <= 0) {
      return;
    }

    this._loading = true;

    const params = {
      role: 'partner',
      page: this._page,
      limit: Platform.OS === 'web' ? 40 : 20,
    };
    if (!_.isEmpty(this._query)) {
      params.query = this._query;
    }
    const {response, error} = await APIClient.GET('/admin/users', params);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    let {items, noitem} = this.state;
    if (response && response.response) {
      const newItems = response.response;
      if (newItems.length > 0) {
        items = items.concat(newItems);
        this._page++;
        this.setState({
          items: items,
        });
      } else {
        this._page = -1;
      }
      noitem = items.length === 0;
    } else {
      if (items.length === 0) {
        const message = Utils.parseErrorMessage(response, error,
          'Có lỗi xảy ra, vui lòng thử lại sau');
        if (Platform.OS !== 'web') {
          Alert.alert(
            global.__APP_NAME__,
            message,
          );
        } else {
          alert(message);
        }
        noitem = true;
      }
    }

    this._loading = false;
    this.setState({
      refreshing: false,
      noitem: noitem,
    });
  }

  _onRefresh = () => this._refreshData(true);

  _onEndReached = () => {
    this._loadData();
  };

  _renderItem = ({item, index}) => {
    return (
      <PartnerItem
        item={item}
        onClick={this._handleClickItem}/>
    );
  };

  _handleClickItem = (item) => {
    if (!item) {
      return;
    }

    if (Platform.OS === 'web') {
      const path = '/partner/' + item.id;
      this.props.history.push(path);
    } else {
      this.props.navigation.navigate('Partner', {
        id: item.id,
      });
    }
  };

  render () {
    const {refreshing, items, noitem} = this.state;
    return (
      <View
        style={styles.container}>
        {Platform.OS === 'web' && <SearchInput
          placeholder='Emai / số điện thoại đối tác'
          onUpdateQuery={this._updateQuery}
          onSubmit={this._search}/>}
        <FlatList
          refreshing={refreshing}
          extraData={this.state}
          data={items}
          onRefresh={this._onRefresh}
          onEndReached={this._onEndReached}
          onEndReachedThreshold={0.5}
          renderItem={this._renderItem}
          style={styles.list}/>

        {noitem && <Empty
          text='Không tìm thấy đối tác, bấm để thử lại'
          onClick={() => this._refreshData(false)}
          style={styles.empty}/>}
      </View>
    );
  }
}

class PartnerItem extends React.PureComponent {

  _handleClick = () => {
    const {item, onClick} = this.props;
    if (onClick) {
      onClick(item);
    }
  };

  render () {
    const {item} = this.props;
    const {name, email, phone} = item;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        style={styles.item}
        onPress={this._handleClick}>
        <Text
          style={styles.itemTitleText}>
          {name}
        </Text>
        <Text
          style={styles.itemBodyText}>
          {email}
        </Text>
        <View
          style={styles.itemDivider}/>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },

  list: {
    flex: 1,
  },
  item: {
    height: ITEM_HEIGHT,
    paddingLeft: 8,
    paddingRight: 8,
    justifyContent: 'center',
  },
  itemTitleText: {
    color: '#000000',
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
  itemBodyText: {
    color: '#000000',
    fontSize: 14,
    fontWeight: '100',
    backgroundColor: 'transparent',
  },
  itemDivider: {
    position: 'absolute',
    left: 0, bottom: 0, right: 0,
    backgroundColor: '#6b7adc',
    ...Platform.select({
      web: {
        height: 1,
      },
      ios: {
        height: 1 / PixelRatio.get(),
      },
      android: {
        height: 1 / PixelRatio.get(),
      },
    }),
  },

  empty: {
    ...Platform.select({
      web: {
        top: 100,
      },
      ios: {
        top: 44,
      },
      android: {
        top: 44,
      },
    }),
  },
});

const mapStateToProps = (state) => {
  return {
    credential: state.user.credential,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default PartnerListScreen;



// WEBPACK FOOTER //
// ./src/partner/PartnerListScreen.js